var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"upload-file"},[_c('input',{ref:"uploadFile",staticClass:"upload-file",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.onUpload}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }